import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { ConcursoApiDto } from '../contracts/backend-api.contracts';
import { CONCURSOS_MOCK } from '../mocks/inicio.mock';
import { Concurso } from '../models/inicio.models';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class InicioService {
  private readonly baseUrl = `${environment.apiBaseUrl}/concursos`;

  constructor(private readonly http: HttpClient) {}

  getConcursos(): Observable<Concurso[]> {
    if (!environment.useMockApi) {
      return this.http.get<ConcursoApiDto[]>(this.baseUrl).pipe(map((items) => items.map((dto) => this.fromApiDto(dto))));
    }

    const payload = CONCURSOS_MOCK.map((item) => this.toApiDto(item));
    return of(payload.map((dto) => this.fromApiDto(dto)));
  }

  private fromApiDto(dto: ConcursoApiDto): Concurso {
    return {
      id: dto.id,
      nombre: dto.nombre,
      subdireccion: dto.subdireccion,
      convocatoria: dto.convocatoria,
      fechaApertura: dto.fecha_apertura,
      fechaCierre: dto.fecha_cierre,
      estado: dto.estado,
      urlDetalle: dto.url_detalle,
      palabrasClave: dto.palabras_clave,
    };
  }

  private toApiDto(model: Concurso): ConcursoApiDto {
    return {
      id: model.id,
      nombre: model.nombre,
      subdireccion: model.subdireccion,
      convocatoria: model.convocatoria,
      fecha_apertura: model.fechaApertura,
      fecha_cierre: model.fechaCierre,
      estado: model.estado,
      url_detalle: model.urlDetalle,
      palabras_clave: model.palabrasClave,
    };
  }
}
